import React, { useState, useEffect } from "react";
import './style.css'
import ReactLoading from 'react-loading';
import abi from "../../../abi.json";
import MerkleTree from 'merkletreejs';
import keccak256 from 'keccak256';
import Web3 from "web3";
import detectEthereumProvider from '@metamask/detect-provider';

require("dotenv").config();

const { REACT_APP_CONTRACT_ADDRESS } = process.env;
const SELECTEDNETWORK = "43114";
const SELECTEDNETWORKNAME = "Avalanche Mainnet";

const nftquantity = 1000;


function Mintbtn() {
  const [errormsg, setErrorMsg] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [totalSupply, settotalSupply] = useState(0);

  const [status, setStatus] = useState(0);
  const [account, setAccount] = useState('')
  const [isConnected, setisConnected] = useState(false);
  const [isLoading, setisLoading] = useState(false);

  const [value, setValue] = useState(0);
  // const [merkleRootMain, setMerkleRootMain] = useState(null);
  const [HexProofMain, setHexProofMain] = useState(null);


  let whitelistAddresses = [

    "0x058FD36A48e1C9980B34b41eaC8a46C3EAF19A41",
    "0x8f0CC75a9e7560A986f07445325076fa310FC3fc",
    "0xBE743Ad22873965C898925B8195272BA12102000",
    "0x013779EE41328cc8d7299F3013Df6352dbFA27e8",
    "0x934b2735E9bF0732A129B19857c6213e1CDb27fA",
    "0xb0Cbb564f3239C230906301Fe20f3f9a9C65f57F",
    "0xAbB3bccA244c2DB75cC790A81Ade3eC4eDF607e4",
    "0x1c839A3fA7B87cD0FCd012666621387F30bE2C33",
    "0x60b0166Eab1339C30e1bceCb14d6e21203688567",
    "0xF4cc91285D7466750E2ED9475006216a4d12F4c5",
    "0x41332Db16DF65945E7f565C841d95d7b0D2f16d2",
    "0xBfa432120F872Fae7907a513F55F0594Ee0f8408",
    "0x5D4d3FaE4d0282FD8A558b5f42Ba700974cBfd1A",
    "0x1b0447013bFDD5E3787769F3336A8E25f6578f2f",
    "0xC59a6382CA93e0aD03cc902876A8D06bE3f47c6D",
    "0x7CFDF6D67B8f94F8Bd508469eDd5ccbdAe079729",
    "0xEE1ecE029595745f81AAEdAb7d715A2f1CECA760",
    "0xe44289B53E5E2Be52229ff2bc854e01655af96e8",
    "0x6E84CC601545B7D44E84be265e4fd44190B7298E",
    "0xcDc02257410D8b20C49DB47D33E18723dDFb9CfE",
    "0xdB652A60a9b326813B21273a13a7D87b21DcB61D",
    "0xBA127C51cAcA07A5624C18681f922F5ad0A220E0",
    "0xf670BEBE5aE02e70942aa7164676353f4Af40A58",
    "0xB35156a4C12C66069306bdC244A94FC005553241",
    "0x74F3acb558017F2987e17d27b1CD101100e33095",
    "0x6B1fCabca3B1040CD57b9D556408b584E1b1fFe6",
    "0x9Da65BD6aeB9d3fdF61FbEa313DefBE047ae7cfc",
    "0x55A92B6c0dB954432563ED1Ba2f72F4BF07f5E30",
    "0xbCaC68DB690b65DD1Ab109279Ae75bfa1E6aEA89",
    "0x43A9642083d1684b59FAB5297591091A3fe47C9b",
    "0xd9d89B45Ec9485089EFF7d776B606a3be23d2285",
    "0x8269e14B9a3eD95DB483861788F3B4f006894a34",
    "0x934F4EAA269BC9546d5E68F68Fdc8638E986c4be",
    "0x9f92aDd1411F5DEF4D44dDE48d315A82511Efd06",
    "0x74C66D8Ee30072eBD1287386d3df4d9C5C46127B",
    "0x167930366F42522DFd1a78af5Aa6A0eC991D5905",
    "0x0B754d6894149Aaf099762b9DA447d56e3d1FB88",
    "0x1BA83B28125B984a9fAE91799fd00268241114C6",
    "0x73f2Ab5dc5F47F9231149fCC24b3cBbC487D1AFb",
    "0xA3f2759d0B29fBD21000D743E54BdD4Cb2a54e8f",
    "0xcF0722F0F8d164529A1aAA4280057103DAea8007",
    "0x4f920CeB5Eda108ca45d608BD9b64103305AD2f6",
    "0xAf2645cCbA6C7c7309D917023A1857bb6BC131fC",
    "0x044D4A08C200F35058A35f38474C3dfD63D727A5",
    "0x5e9E984CF39B965788488e0b635547b02B06a379",
    "0x8Fd63cc9f5FEE917f9E0F492e8Faa2AECa80CFb2",
    "0x46beA5C54C50C71f3d35bCC8d932792A68007e6F",
    "0x90d8624Dc25ADe565ddb64F1d51992F9980Db5f2",
    "0x99136DF86921635d2b62F4EDadA1c943E21Fbc98",
    "0xaD08C4957dC64Aa27722fE922ca67E8116ec3e0d",
    "0x517618b4e84DA151DAe881aD723521824f00A94f",
    "0x192c552F4e87A15867389f4Cf1F6C5d1E89E857C",
    "0xbfF54b44f72f9B722CD05e2e6E49202BA98FE244",
    "0x7745b2F563f027b31615ECb329F44BDc291B5CaB",
    "0x59686cd22e521d420B860EE2bbCc081c2213e13a",
    "0xcB4f9A94363D688E11f5F3d87814aA492092ff97",
    "0x14fABf70C23e97d6E44cD377Ae86963cd6907573",
    "0xC41070655B12674254A50d7e517A6aa5aE3b3823",
    "0x8fBbDeb1C4F8fd058beD754c6e0Cd93d7e7165e4",
    "0x25D6BD96054dDc97051166fe12D51Ae70E8975Cb",
    "0xdb98DEdc91A92EC809C34123CA6D9F8b5FD3b0B3",
    "0x164b47478fB933f3618f630941Fca87bC3969921",
    "0x6Ea1881e0F0F126Aa9c8BB33EB893B197bb9BE31",
    "0xBC47C825760d8e6f624B6586763C5AED38f8Fcd1",
    "0x352E2438a01B12ABF9a14041aAfA584D3eBEc493",
    "0x35A4dbf5fe3D8831c7479E9D51184a0b84ADE0FD",
    "0x77e64b7891E86fa7A424E95013c746251763acd8",
    "0xBb1F48a57c998E8e15b0399FA3472fEc404932CB",
    "0xa7358592fb3425B20408E439B8C5A051734CF6D1",
    "0xaA8167dE65AC8951492Fc20b43929A2Ba085C8A7",
    "0x5C56458Bb262Bf7C669BBCD01D4eDfDb2Db5cae6",
    "0xf5d7bb6cB58f746dcB087C0d4129bEB249730723",
    "0xD042cA73589241a25585823B3F34b42936E61462",
    "0xC658127D9E149eb96B2c75B20E9aCD43a9Db9ee8",
    "0xc3a6EA28023aB78570A3A51A5d2412080eC53E2C",
    "0x6bA9DdfB9d1A8E84d691164fae1C900768C5ECe2",
    "0x9660FccDB11E70493858109a02019e9478886f30",
    "0x776702FA0bD62100A0428fFb867b8928F60c91E8",
    "0x473E10733e21754d7d1e00EB61e4256e543dfb6E",
    "0xda0bC3Fb94975E0F802949E83Cf9542A3585cf3C",
    "0x680c1484fD242531578f0B85790AE656C98fEBca",
    "0xffeF9c8c6E9e9689a40ACBbC97B00B8Bc02B6efb",
    "0x8Ec429E19595F996b2c941012EBd4c9B437C5c26",
    "0x6308f92bF8f2250e5Ec08132f5D389383D0E2F1C",
    "0xbc6214115d113E3ECf5f2dE9E79dadd9006c7465",
    "0xA8552B96acBff136027ADa92c1c3b3F2E0FED049",
    "0xFCD3F0386e94aa1eA17aeFEbe65ffc89235C9487",
    "0x06E5C00c6109eCC2635df8F83701B61D287563AA",
    "0xd80266e61dec6427C192efAe2DcE3B8714e30ADE",
    "0x955daa92586b4fa65847d4b09cE24fa5a46e2d82",
    "0x6BBC66aE722f3020E9CfD388F2d9322769DAD9d2",
    "0xc0fDb6C46f3dF6D5fa43633b70Be66E69bFA10B0",
    "0x3B49D277d69Aa85BF80B5803bBF05E0a7C5a3F07",
    "0x77459d937E6b721b12b5cc59fA46A515616B47a9",
    "0x9D05836d6301428A886e8a123da881BEE7bEA4c7",
    "0x8BC924D00880B2609E859F21C3eF56184eb546C9",
    "0x07Df06E670e15D649Ff689B9F88B201271C0412d",
    "0xbd94a72bB0450d3a3b57089b27B5aF63Ab7c5fFF",
    "0x88A3268a11a03BFf28c01Cd9899c34Fd42660273",
    "0xe892CCCD9617Ff003ed8a08052C258fb59f907f6",
    "0x1eD98B0dE134D1dd67992Ee83ed91ac69281DD29",
    "0x29DB702186cE4397A4fF9396835851F9667b3082",
    "0xF9e397c93A6c63Cf0fDB3811c95B7F153eD8370B",
    "0xccDD75fAd9493E3C1279EF97bA3c8Bc797a7CD98",
    "0x02Cc04fBA11f24db36F03E493624946132f8E74b",
    "0x587522E5eC2cFE5153c3d23bA1283202bc20e044",
    "0x458d0432ECbBDC0B964E211EBb451f2aC027be40",
    "0x727d75755232c2719496A1B67dEE51a0e3333CA7",
    "0x7E61e5e6127c269e89886BF52f26c77d48633aEC",
    "0xc74bBe3f91A783d7A665361c5cAe9975561853dd",
    "0xDfC8711d0024873CfEA92025856BD63fc10f9FE6",
    "0x75d783637A2ba5c702466cA93FA2c6FC3A443aEC",
    "0xe5E62eac4126b18228B0d7554988e96bB2c6CC2a",
    "0x756e6764f6518cBAD89784B4bD3be4237630393d",
    "0x56a7d004f3413B11c80d8aa3032873EEA5c0D128",
    "0x7E10D19Df4dCb03118748A1Df0d5e0627A701338",
    "0x2BA4408279CE96237Ae65F0C23E8667cDb5B7E83",
    "0x0766ad4e4c0165339C816D7907980De551E8669E",
    "0x29E574941643BDbD95C1e485A34c06CB1E0B5ADB",
    "0x6c91a6e7052894753A5d68C782Cc49E11f9d5b08",
    "0xe91ea67b8A63E7c47A860750Bb441a561d58eAE6",
    "0x662dEDfC495efC78A9667F40ce1457461342B5cb",
    "0x94823E9e35ce750022924023d0096ddbCd8c27CB",
    "0xc4680f7E48fd44B9AA9049A6D795607b1482422C",
    "0xa5B0f0faC4027486a6c9237B1EC49C30f9F4653D",
    "0x3868dC6487Cc0E1ec25ad8aDFB01e076E1a5De69",
    "0x26Cc7534ad3832b0f3C801e6926b218c44B8B902",
    "0x072b8F9008aff55767eF877e153C6BE631672b9e",
    "0xc8Fcba78BF0dA91159a92193f658eA1Bd0e13C90",
    "0x5927DDB5A83DDcf03f234C9b3a47842179182029",
    "0x5cBFcBdE6442AA2E0E826B44Ae85a88d2d500687",
    "0xFEB51E6f307FE0B19322E670d7bA628EF8cA7a65",
    "0x1228D31610B7cC566c55e74DF852943D680EC1cA",
    "0x16d6d4483a711298B9Bec552DC66a508e738466D",
    "0x4ec3fF0aE1eDcC1F7250Fc2b8422bc56371140C4",
    "0xe32eD3E14701a895a1b7d309800601aD433e7bCC",
    "0xF06b40ffc8469f1dAC63b9671412b093faFb1197",
    "0x08EFa54C596790ADAFdA045E19891917C864AeFE",
    "0xE3420eC4517D3370F82E6f995A34Bf2e1511B8b5",
    "0xdEB153d256CE8ee10539F5c9e811Cfe66f9BD117",
    "0xA7Ad7fF576D3616D24745B70772678F205356850",
    "0xc46ABD6008D25b1a92413Cab37Ec7a0Bc6f07CC5",
    "0xd9cC3D7a00c332B965D94358e66F93dC11b42E43",
    "0x172db20795076D360F02549405fC6C53421baB9e",
    "0x93fEB76bE77025c8a7494a41BC8Ae4564fb88822",
    "0xB99104be06A52D973d369056C11A9d958211E563",
    "0x2992660328682E6fdcD3B17C6533106bcE222f47",
    "0xea376C0c80BBa7fEc9C07c9ce46657210b014eB4",
    "0xae898f9D3996eC4D5Be6a4E6c70FB327de848Fa0",
    "0xBF9e9b65A2919ac61cb93b2517666e680A25Bce3",
    "0xfe9c0D10957eF06Bda064F9Ad5e1b685E3A1ea1B",
    "0x2Fab6113F9ceE2ef41BE84Da4493114c88EdD316",
    "0x29C592C7AB5d0699B697272aE301a90dd0e857Cf",
    "0xa7B11Cf30C4551cffdae93657226004e45225ca8",
    "0xF6DeD6DBaF3F05f1AD962BDC9852554E08e18963",
    "0x7173eE579e670ECD5c2bc2b521e802C4d3860948",
    "0xD757938aF5ff56854d21FDa09c4C1662BeBA5Fae",
    "0xb3D400aaF553116B66CCC7C1Fb8f14ce0E369E34",
    "0x3903d5eA4ECF8D41091A461FA48775d0D63072C3",
    "0xD29Fac590Da60A39856cdC166C94D6d9524193B0",
    "0x0574C56f5799A29f1EFd854dc1f80c3789B6f5dd",
    "0xA51B691DFd862dB64913Fb7663208D39c51e8740",
    "0x0C8DCb068395BFC472518960c33964b4825CAEb0",
    "0xe7061cA21af7b6Cebc4d04a3Af2CC5347AAA3c3A",
    "0x90E00542476e30Ee471A60ed42a70d06E6d3a1f1",
    "0xe1DfcaC40aCf8654Fed785B87a26B02a90c4436d",
    "0x7C483dAd856C4C15ce89709EFC73bb07Ca5Dba25",
    "0x623C04dd784cd3a937AB8511BbB165C872223A32",
    "0x4F9107EfB7003476C60452478A7cF961E979fd7e",
    "0x7a8E5b5Ad1c12B5B207a37b13E043D43aA098866",
    "0x9FD5f9423b97f258be382f50cE3B389C142068B4",
    "0x8e07a8dDcAC5E12dce385C857288a2FC75a78812",
    "0xbd3082bA74DB0938d682C6A1d9B8734eD6c11312",
    "0xDdE5713315Ad5f109A72141c3a5fd4bE972FaFDc",
    "0x117b37793D3613Da334B32c8f4e890800Fa622E4",
    "0x1F07BdD3250237D155376b9718F3F5106880727A",
    "0x62183551879ffBB6FFa6fC867a9cbb3Be483c745",
    "0x7ef1A67e2796Ade38dc28CF5981704BDF0C1FF8D",
    "0x0Bb4b0BF8D1dD7621f493f1a68ad0887d4E5b478",
    "0x7c9bE067E111B6CF315281266eeCfE94cdA2F9E9",
    "0x708670ad43835305Eee4447e378801fD72c86c9E",
    "0xDD82390C9b2311e1A6378e9B91697542303Cccc3",
    "0x0E96A4f7B7ce3d48b3ad9a61761FFC041a8DdBEc",
    "0xfa6d57a39D7eD1b0aC111002264465f05E4bDA3B",
    "0x93139823bbab2F766aa1Cf26f2c665Eec494F7B2",
    "0xb7562d2AAa07392edbE12c762658745C38EbFEe1",
    "0x1fdce95B3FE6F7E954B26cdb3417FD83e9E54a8e",
    "0x298b5745404834613d198C132798a54c1b5d9BE4",
    "0x119E6E00D4E459Be1d8229EEdE4689Faa1409866",
    "0x5c540775742A5F07D2c4901b41f269F72fa8f96d",
    "0x9cDA362fedcc3A24416741a1FD32b099022E2884",
    "0x0D428F6c7FC1C6F1d58865396554bD3959B548f2",
    "0xe7E281efB6779c21754129c10288955C5e1D6FF2",
    "0xB692F635C2826F5D69d4fF277Ad3c4b69EE2e8B6",
    "0xaD10C74192346579dd9474096e36652eb2632923",
    "0xA8cFa8851a38D2bC7Fc1839fa338be50F315f6C3",
    "0xf4cbdEACeA9091F82964d15B8A449fD91b5007Ba",
    "0xF7B7Bce6873484779412E5CE99aAD6A02257A25f",
    "0x2bF28E737d77473F3EbAeD01ffC0e483867F85b7",
    "0xc5f2caba120da1a6c52063b1d32dfcbb3167ab9e",
    "0xD1AD169A6d0ccaD1EB829c1744C27cAA5297b9DB",
    "0x8b37Abd08CD0b408A3A1B48b2dDA37D67AD87723",
    "0xc5EDCA5Fb4f26fEECb1BA081F0150666EC2cC150",
    "0x621113b3B059D0B7Be7328f810991A7701880F52",
    "0xDCF6ec1BC8b1Be3d6068476cA148418FedBF6547",
    "0x13898ecF5c0f7B5bFc203C8f1F704841569aF394",
    "0xCcC4bCd15D406FB31bD6484CBC3a98834e4d72c7",
    "0xe9Da6dBdB7441E360d441C331851ef1dE35ed195",
    "0x1c206A2017346BaD4FF0fDe1bc987fb9bffa3F60",
    "0xB959Fde47F44cf19f5088a09D0Fc1d9338c53b75",
    "0x55f3d245431cC4754713509e5dc63a2De87d7c5D",
    "0x1630f28D091146Ee7dF5322b5f7E50C5A9BdF9bB",
    "0x045456712b1110810231b541f25f7B8C445E61b8",
    "0x8C80C2770ca5b4A16CF7Dd048739A291AE3E754F",
    "0x32340C217793cFEd85e8382000a0Ba0A120a227C",
    "0x5BA5b1Ed55ACeF2854274691062eEAa4281660A5",
    "0x2dE60E79Cf19c618f2147581913C839ed894ad6C",
    "0xF237602091A4548ac1F3b86cb991c792cC515AAd",
    "0x51f130408c88447bfF2EEEd419EE2E2D196C3b9e",
    "0x65249f7e61b301F73D961637483072A5B5FA6290",
    "0x4BCC6bD9Dc5753f929334065510772FCe03A92D0",
    "0xFd2db5F95B15D3dbeaB1dF18d9cE8dae77b78Ab7",
    "0x6001969972f997d769C6D0201FA41351c84d727e",
    "0x209D76d4cB9311eE64F27b575D8409a5ca55BBD6",
    "0x18089B9DA6cB6E0259B38964fA756Ad801a587Ea",
    "0x441097EF3fd5B7EB90421F438D6A91629707AA83",
    "0xc9bA8B16F0b2e2af16A5d971d3e7A39881E41324",
    "0x82cFe9bCd84296D4e4AFF1Ae9058f1dF26912702",
    "0x396a942301b345984C60F288d0C7c6B9fBf06ec2",
    "0x00847065b8D265FAAA97855533E23cf92959869a",
    "0x0107A9Db55fFe958F2b882142aF38df731f48BAC",
    "0x015f4A261615438420e98329e37dA55C7f2aA0BB",
    "0x016D9d9C63b008bB998a911cE1a4D413404fbD9e",
    "0x02299Dc5da884A1B5Dc1Dc76f1034BB1B05b7F22",
    "0x07d475C841F62731e039ca3C18D423fB38c6A0Dd",
    "0x0a11acDd1fFBDb8ADfc34a84f1836F360e6f3CCE",
    "0x0Bb805803c897Ae246751521D662f355efA691Ac",
    "0x0Bd4AB2631E6A84b18d5bCc01d03423A73a1Aa1B",
    "0x0c48f610461Fef5E8e9376267121e8B4e678d5af",
    "0x0D0Cf1282d6d1ac4A2311E6b32Fae01092384DED",
    "0x0E9b37bDE03143f4A99Bd7b209263E557188aC69",
    "0x10ffBe848ca562Cb961BC9E373e2035EBB67539A",
    "0x120208F30BE64860AB919aF1997EA2FF6760962B",
    "0x13B05CE27484fCB5646240FaEB271C78eF83309f",
    "0x1725dF05124b6313fC53Ec8fb81387E501Abb475",
    "0x1aeb5648c63cfc56f54012206Ae9e2af0c1C7Bd9",
    "0x1ED8C535FBA58B6b5E35a6eEA4755DE3Cf5848be",
    "0x1fb42CcFc481B8cfFa6F82879A93749d21413613",
    "0x1fc7ba83E89BB974FE2D249dFa115A868dc864e5",
    "0x226BD43A2f91870f1cc0ff247DdCAD09e0F008aB",
    "0x2412F93Ac9feC2A38E62332A970515D79f068b8c",
    "0x248326422E6148FB554457CB19Bd2836a1236BD8",
    "0x24e523fD8cEE363A4D90C7c9C9ec5D2FC9A8b02a",
    "0x2562B61F4931e2BDc46285288A32574F6091b3ba",
    "0x25bb2CeFBa8285b7d4CdbF1A202d77F5d4D55CCB",
    "0x26A2996b1AE9e66cd81DB1a9701FBb3B3b120617",
    "0x2a38D7d708b81971fbEF32a53A122baE08042B59",
    "0x2CEec8Ad179a445a17586e6C2e1E0add91fC3847",
    "0x2fA2751328376b604701326a3C8521bDC2929bcE",
    "0x2FCc617e32C7E69e5cA4004dDC2A6f3C67Bc65b8",
    "0x302F7422EA2Bd6C18f413227084d43581BE18996",
    "0x30CD15f16F16B65c1a93CED26db6c9498E0522e8",
    "0x3109E9c371785142A45a29d21a1F803F48c712F9",
    "0x313E42DfCBFb4F845077aB1Fc81a8040D675f6E0",
    "0x346bB36AFe5BC2AAf7a07587E33F927bEFD842B1",
    "0x354AEEC9E3ff0FaaDdbD501023e11870348DC4Df",
    "0x362117F5fCaFFa0d7639f19192Ad248E3F422F7d",
    "0x365D764c1AeD3bbcD64A37F08D2E85A702fDDA53",
    "0x37013F8364d7359D1FFBD00933664881Ffe2117a",
    "0x390277eB6C98E318Ce8DC41F92A6E4E0Bcab6C99",
    "0x39ea09b6d33753c9e3A55e705a4360Dc7859461C",
    "0x3aC717D34eCEa371d5D33e9E145A92Ed08871Cda",
    "0x3B58d8F8C053f034dE73e5e4DC2b39c922837308",
    "0x3C25631A9d36eCd1e4aBe55d4EaBffe7BfDcA1A0",
    "0x3dfC31A96AE12E3c3aD48E593B9a66A1B6f9993c",
    "0x3e1B24a7070A7Af44d93EC681a85b729BC6a0Fa9",
    "0x41C6741F56893Fc194384f44f8d647485ca26Fe7",
    "0x43481E045B140b8bABABf151568F73A223060B02",
    "0x434fCcD6369EdEd1a448eE3d9dE1DC547ADf502C",
    "0x4494115c11bd22e6cFd1e8e885760698c66AC609",
    "0x45667A695730B0251b08e367C249D50f2b7921BF",
    "0x460F21C41b12eb44C89Cb3F50755286826D407b6",
    "0x4613B82f7C87d11406B455414464fF3F495304cb",
    "0x46d20C90305dAA6436475a21Ad14d2f6fce18F89",
    "0x4A8EF91397343F53a1c51e71d2E5e10D85F8FF4d",
    "0x4b957358D924237A99A6548F6Bc3833646962499",
    "0x4baa2F4f88f9e175E139E883D726DC4bFEA3E594",
    "0x4BE2F694f681b060b3f764e7CDB008f973e3585a",
    "0x4c1500063ded7E9F54BC9f7C8C19F8a3651286D1",
    "0x4C28f468E92a4A16290d6FD8be627caC0BaEf43b",
    "0x4c995Fe2651851C07F1bF871D1Ef83bAE25B2632",
    "0x554B27999600Fcc0a6Fd508a4c028c8A027d5bd7",
    "0x57201f406818E73D274824eF71c4207d82fA38d4",
    "0x587D992514E3F0BFE780520FB35a407B8a48Fd8e",
    "0x591A93A160b7fD7dD41203734AAF464Fe2387604",
    "0x59F88c3299e1AAf7FD3f89B9A40890381D46f8E5",
    "0x5F150369C94E8c0fC10e3a14a745f94689EB2fcD",
    "0x614A87A2c9D39435A2f7a2479658F9Dd23Fc1eD3",
    "0x6169896246582bd7b310Beb3EEB25F451e363Cf2",
    "0x6362D254885CCFC02629116a5ca70d43897aB7d2",
    "0x67054642297502974474F7bFd61cFe7952087040",
    "0x68b01232E983DD28f002117C677ADd69a87fE5A4",
    "0x6c00270aCC349BC5D15a945D2eC75bFadc54f23f",
    "0x6d386C2A9de442C7A69884a7aC76d57557dE4796",
    "0x6D424cd4EA7F54eb0b21f34844eF820EfA091b09",
    "0x6FE8c54D4905DaB438DDB17c5a25FDC13B9fF485",
    "0x725301661aCE7a297CF2BCd926f888a5c890F114",
    "0x72C68064e9A2F728521aB9C8bee7267c5c610747",
    "0x74E5996A87A587987E7347d154C568A92A0B1f19",
    "0x75DEB5b27a5cF036F217636ae41c38fa42e48F4d",
    "0x76C0eFECdFb8593fA4428EDFDC8E5a36414c51Aa",
    "0x78da39904Ea6A7A97Ba74Ba7ab560Cae0444b6E6",
    "0x7AD6263Ef90fe20e5E517f54529041DE6f58f107",
    "0x7b533c38910Fc31D9ceA53BF91Cda053120f157e",
    "0x7c6d3FB0EBC44D9D1beAA746a315572cd1ad1CA7",
    "0x7cF5817c18488Df8e68625C30E90f76D88c115a9",
    "0x7f30B32550437BE48A7720Ba1769F5b61D32de87",
    "0x80Ffdd72fa17Ef4C51fCf4D9Cf3aadAbA2E26Ce1",
    "0x827e6964E682C7C9fc30B11b7FFa2e347a826228",
    "0x8418626867183397355AFB3eBA16442c1eCC23c9",
    "0x84b5deEbc3669d600d4E05AA24957436E5D957Fc",
    "0x8599E0917E66CC3A187441c83Fe5DD1fB7169253",
    "0x86434C4a65A658EeC98BB452cC8dC4e403eEdea0",
    "0x8657071da0d35fc330914C15ADAd6E15d9b14E15",
    "0x868DE4f33Aad358E52F850d14211f1D89DFF3FB3",
    "0x8a98B71be49A5d4BFcE09a83bD270D1a5F82103d",
    "0x8Fc14A1f4085E1df4E0B30A8b2EbA237f07Ced14",
    "0x905b42a4a9f366CcBc182Ece8ae45Db274EC240e",
    "0x926ab76bB0ab4C82940cd1315E3caD7010F2A41D",
    "0x945A21E3277E6Aabda145DA4cBabBF6d592fBCe4",
    "0x94a308Ff2787f6A1398159010D547bf6F7cd82d9",
    "0x94e1B982b7fF8c0Bd4E7B87ee55d3c2D49A59694",
    "0x986Be878f30BbaC1bA7F579A80ece70E07445438",
    "0x994da9A3524A473a19eb6750Ee59acc495EDbf68",
    "0x9989C4e03dd07aFeEa4877EE9e0fA59f4ef8D3fA",
    "0x9A2fF2EaB314C23c127C4879618B8c04874B5d9D",
    "0x9A671951DF95d8eF43313bd7e2FB522EBd6Db0db",
    "0x9d6A280FC42333c087Ec12f768a87eE68d1F87D7",
    "0x9De89422AA486f9Cb30aA308DE9642B5BDe9AD1E",
    "0x9eadD4a28d2F121cDda80e449abfE91dC9e438f2",
    "0xA05216C3648CBCA24cC8916Df5131b2B9eD918bC",
    "0xA18aa22016083C5faA2D0B523285d7681a7DD637",
    "0xa32416271737FdC218b74AB9e6E6803Ad7793690",
    "0xA59CAe87d9Dd21474f717F769A27cE3Cb6B9C826",
    "0xa7A183437CA3144a1f67E19871b9700Fbcd291Bd",
    "0xA932147222C931732A2Ca90CCd769fcdD914e2EB",
    "0xAbeb50481A7b97c76567461946BC5c2A6F4Eba48",
    "0xAC690011AD79646972f9687c97A67d7dAE7860d4",
    "0xAD7B2bb00312492DD5Bf30B22B6E3f4BE50e079D",
    "0xaF1E0B72FCdB37b07E7684029524392619EA309B",
    "0xB06e1b09CEb5c72C5661572C5c605f8B7A45d2f0",
    "0xB73308Cc4b2Ded6077E688510f7150Beb3A450e0",
    "0xB7563eA2011C7186d5c8Ec9105Ae6a2ebB60C1E9",
    "0xb76Aa91f605AF85b289fABd6d8396e2D2a5073E7",
    "0xB8C750EF84Ee44F97a85803BAD81252F578332F8",
    "0xBbB45024A62cE17f9080452570272FCDDd36e0d0",
    "0xbd37fe43f023d752c43eCB45e4522223fC2576D1",
    "0xBe8C58f2579EEB5d3c3143c77Aeb8b87632A296D",
    "0xbF1a53e1f37A886C68557ED827889D3AA7ED2589",
    "0xbF5efdea288876F57e3C80b2128c9D6683A3a125",
    "0xc06A915208cBD2D241E7648357A054dc975fA01E",
    "0xC649DcDD629afA2c755FC186bA11a12D370ea2Bc",
    "0xC7f308e1e474f6659F55110beAcc13Fef2e7DdF3",
    "0xC87bBF954aF1551B9dD717E17f99277C61D2D893",
    "0xCA064254CAa0e25249B5f00373206f31F1b92FB6",
    "0xCA111b0dAf26D493fCb269cEE7acAA62755B350F",
    "0xCc1D42D4F6184Ab5f8AEFa1907d754b123d3f1FA",
    "0xcde03566d2d324bC2Fe22581E4D9506779E1e451",
    "0xce50C962A2ccf4C7dAd818fc9b68eBEFFb6A810a",
    "0xce62ec58396d56c18E6EE35C885025539fF3cA0b",
    "0xcfcff9E4FdD565e4f97AE358644428fD11aC4eeA",
    "0xd17EC218c62cf3670564C6cF3D3f2ADB4C16d031",
    "0xd3020016900BE232D277743d10893064bE7CC7f9",
    "0xD32CE22E32919dC44D40Dbc65BccE58B50041E13",
    "0xD3Cf4ABF08CA1107C2CB25387DA62fbAbfDf1C9E",
    "0xD4e610d2bFA2439673a3a0F3838A60A30b609793",
    "0xd4edB2c764a0864772C6A42c41cbd3239C7B5d2B",
    "0xD7268cA349c40223511A1d2386C3457837e2FcA0",
    "0xD7A91810541b6Cde677C86fF18f5f3F659ec886f",
    "0xD7C18bb2589d41C5e463E90a40384CF07B89Fb10",
    "0xd81F99d353210C2B93D3A878D3061C3C46330687",
    "0xD8C1302139dfba8633a206882Be2A3349ee32d0B",
    "0xd953C648bfbeb5e3A602c61547856C75fc2CA036",
    "0xdA5ef65E520B1F126EDB17a207fa13fC37098a23",
    "0xDACd25202C931AD6edB15CE12E8ecEFC5EC4A735",
    "0xdBDa9cFE26FC3C9c27954992ecf810F26f6Ee30b",
    "0xDd280Ae3a73fd496f4E986A28eeAd176da9a8632",
    "0xdD2F12E69E0d971349820dbe240EB181BE789Ff1",
    "0xdd343De064bfB1f779DDE5D09a9dEfc296c56a4a",
    "0xdF6dAbe38beDf310831Cbd1a9b2ce097d5B057ce",
    "0xe0edF6ec9ff24801515DC91104000414a5a4B3Cb",
    "0xe1C9881B973b0D973b2f714B89055e270Fbf879e",
    "0xe2321a99D054eEEbE31dEd3451a294136B0d1FFE",
    "0xE3E2CB9bc26D733BB41Dbf518ccFd0940B6fB9BF",
    "0xe416b7F6Cf664FF71E68837Ec9aB20aF839A3B1A",
    "0xe46ED3Abd6D7B19f7fE7297A2342d31617987277",
    "0xE6d9AF2AED9BA455bBe082D63f01491402c8eA88",
    "0xe75FfaAe0E3c5A6a9c9955680c8ceBDF17a6D0E6",
    "0xE7D30b72064AAAf53338400F8F1B6CA6Ac5B6D4a",
    "0xe8A8eA430c4b3F53d87613D059DDE74922584468",
    "0xE8f07c73A8162e5cf0838D76AE244C08EbA23876",
    "0xE986ebaeCcB44EEfaFa1b69e8102f12a2D320C32",
    "0xED3c6C46C2d8aFCA983824056CB4E09b080D3294",
    "0xee096417D22CD50C472EDBE9438f851Cb50199f7",
    "0xf0b9a141988A552ed696Fb6Ae1Bb205621d1E046",
    "0xf2FB039Ff4A6F71a09AD5d0c7612978aB874C6cE",
    "0xf3f28Ba4B6ad540915F453BD05e7833eB99433B4",
    "0xf4981B970Da3A553A2E0a3aaa964605602d2B6aF",
    "0xf525f47b64B012cF3Ca2bd3Be95949453ec5B253",
    "0xf75f6c074959bfB1cd2AE93AF105E925548367CD",
    "0xf910c194F790aFa8eedd28439d297b4A2FD9DDBA",
    "0xfC5480D57c7dBFf406Bc8Ad7044BdaE7A8FEDECb",
    "0xFCEADee3c7F5eaF126BA8248D11A3C77Fc0DC1be",
    "0xFF64B5c334bc1d65F1332D770C407a31FD19DCAe",
    "8t9xQhStpLDbKCjxf5Uj6oaBexexVYr3rBEsL5XuUPWX",
    "P4y6htc6yDy8s4XLV656Vq9EsygYVZx7YGdMW2HduD6",
    "0xDd280Ae3a73fd496f4E986A28eeAd176da9a8632",
    "0xaBd53869c56Fc940462bF37fd1f20F59fB0C8942",
    "0xBbB45024A62cE17f9080452570272FCDDd36e0d0",
    "0xe2321a99D054eEEbE31dEd3451a294136B0d1FFE",
    "0x3C25631A9d36eCd1e4aBe55d4EaBffe7BfDcA1A0",
    "0x4c1500063ded7E9F54BC9f7C8C19F8a3651286D1",
    "0x4613B82f7C87d11406B455414464fF3F495304cb",
    "0xe0edF6ec9ff24801515DC91104000414a5a4B3Cb",
    "0x955daa92586b4fa65847d4b09cE24fa5a46e2d82",
    "0x0Bb805803c897Ae246751521D662f355efA691Ac",
    "0xD3Cf4ABF08CA1107C2CB25387DA62fbAbfDf1C9E",
    "0x8657071da0d35fc330914C15ADAd6E15d9b14E15",
    "0x9Da65BD6aeB9d3fdF61FbEa313DefBE047ae7cfc",
    "0x2fA2751328376b604701326a3C8521bDC2929bcE",
    "0x74F3acb558017F2987e17d27b1CD101100e33095",
    "0xDACd25202C931AD6edB15CE12E8ecEFC5EC4A735",
    "0x94a308Ff2787f6A1398159010D547bf6F7cd82d9",
    "0x1ED8C535FBA58B6b5E35a6eEA4755DE3Cf5848be",
    "0x07d475C841F62731e039ca3C18D423fB38c6A0Dd",
    "0x90d8624Dc25ADe565ddb64F1d51992F9980Db5f2",
    "0xE3E2CB9bc26D733BB41Dbf518ccFd0940B6fB9BF",
    "0xCA111b0dAf26D493fCb269cEE7acAA62755B350F",
    "0x39ea09b6d33753c9e3A55e705a4360Dc7859461C",
    "0x167930366F42522DFd1a78af5Aa6A0eC991D5905",
    "0xF6344515d31957757c7A3eb552E1087924904eef",
    "0x680c1484fD242531578f0B85790AE656C98fEBca",
    "0xAc7B32f010a01231C6f081919169BD0cAa031724",
    "0x934F4EAA269BC9546d5E68F68Fdc8638E986c4be",
    "0x13B05CE27484fCB5646240FaEB271C78eF83309f",
    "0x4C3363779d60B78f97de19c7E9f90d6d7088535C",
    "0x2Aa7F6fE41A424B3A2cf3ba23D387801dB8E3fbc",
    "0xf754387C678d1259036d52CeF7FF55929B6BDbe1",
    "0xA7Ad7fF576D3616D24745B70772678F205356850",
    "0x6BBC66aE722f3020E9CfD388F2d9322769DAD9d2",
    "0x013779EE41328cc8d7299F3013Df6352dbFA27e8",
    "0x441097EF3fd5B7EB90421F438D6A91629707AA83",
    "0x10ffBe848ca562Cb961BC9E373e2035EBB67539A",
    "0x15199ad0EB763F50EFa50e25e31a3BAb1eabA064",
    "0x11b3e93C56AEc44720e69c1F114E230B907838b6",
    "0x2FCc617e32C7E69e5cA4004dDC2A6f3C67Bc65b8",
    "0xc0F9920d1040531CDCBF7d41aE4C87CB04A6c5e4",
    "0x2CcF39d2D0D18A1721caBFCC69724c7275474055",
    "0x945A21E3277E6Aabda145DA4cBabBF6d592fBCe4",
    "0x5BA5b1Ed55ACeF2854274691062eEAa4281660A5",
    "0x87A399FcDAaCeC1052a90103716f51BD75d4bA87",
    "0x2Ef7f5c8ff380601e59E2Ca09462C23487aeE3B2",
    "0x0107a9db55ffe958f2b882142af38df731f48bac",
    "0x473E10733e21754d7d1e00EB61e4256e543dfb6E",
    "0xd9cC3D7a00c332B965D94358e66F93dC11b42E43",
    "0x785CBEe20A31cd7F03b62cC9879607d4138de152",
    "0x0134266AE5Ed7d3392B3Bab752d8CB0f91b9DAB1",
    "0xac82cb3bc7188106744bbf618c37c717841af8b4",
    "0xfD037C3b64dDeE9FFdb15eF9bb79Ab9299F346b7",
    "0xc55D5dFAf2F22B2d703d728d93AA4B2F61EB3914",
    "0x4A5c05eFcFE5e710dE0f29d17eB4ee8c2212c85F",
    "0x2c3F1549002e429C3d47C4259FfEa66c7aB63282",
    "0x6580cfA03A0927e060bFE166DD50c3617F591E0b",
    "0xAB047519B91ab7A1e4D43Cd3784A6BD3C82c6367",
    "0xF7d32344c8e9b0d9Cd57FE15BAd06c6924B9263E",
    "0xFE58E6a00279cb0736dB0c38E1f2A768b10340c0",
    "0x0Fa09f0f3B63aCC3118ea033d4f8a3edfE610A14",
    "0x3849126e937b9Aad4200822955e1b58F9817fE7E",
    "0xc06A915208cBD2D241E7648357A054dc975fA01E",
    "0xFE58E6a00279cb0736dB0c38E1f2A768b10340c0",
    "0x934451f20eEeD042870b24D2E314D37363fF959A",
    "0xc06A915208cBD2D241E7648357A054dc975fA01E",
    "0xaA80d2b6e1b032C3cFC6A1D4f899B7CEb75B4332",
    "0xcDc02257410D8b20C49DB47D33E18723dDFb9CfE",
    "0x57AaBFeB724323034EeC20896a2A694C6269eb6b",
    "0xa2e1FED6cc1f9d395259c0C11306129C1493e0D5",
    "0x7c6d3FB0EBC44D9D1beAA746a315572cd1ad1CA7",
    "0x623C04dd784cd3a937AB8511BbB165C872223A32",
    "0x4ec3fF0aE1eDcC1F7250Fc2b8422bc56371140C4",
    "0x1F07BdD3250237D155376b9718F3F5106880727A",
    "0x934451f20eEeD042870b24D2E314D37363fF959A",
    "0x15199ad0EB763F50EFa50e25e31a3BAb1eabA064",
    "0x2BA4408279CE96237Ae65F0C23E8667cDb5B7E83",
    "0x994da9A3524A473a19eb6750Ee59acc495EDbf68",
    "0xd81F99d353210C2B93D3A878D3061C3C46330687",
    "0x396a942301b345984C60F288d0C7c6B9fBf06ec2",
    "0x3bA0c63b1226e46420c08752A89C24E8F565C572",
    "0xc55D5dFAf2F22B2d703d728d93AA4B2F61EB3914",
    "0xfD037C3b64dDeE9FFdb15eF9bb79Ab9299F346b7",
    "0xe42313940D33D5602Ee9BA15Fd8868D912Df5CB7",
    "0xd81F99d353210C2B93D3A878D3061C3C46330687",
    "0x2c3F1549002e429C3d47C4259FfEa66c7aB63282",
    "0x4A5c05eFcFE5e710dE0f29d17eB4ee8c2212c85F",
    "0xAB047519B91ab7A1e4D43Cd3784A6BD3C82c6367",
    "0x6580cfA03A0927e060bFE166DD50c3617F591E0b",
    "0xF7d32344c8e9b0d9Cd57FE15BAd06c6924B9263E",
    "0x3849126e937b9Aad4200822955e1b58F9817fE7E",
    "0x0Fa09f0f3B63aCC3118ea033d4f8a3edfE610A14",
    "0x3849126e937b9Aad4200822955e1b58F9817fE7E",
    "0xFE58E6a00279cb0736dB0c38E1f2A768b10340c0",
    "0x934451f20eEeD042870b24D2E314D37363fF959A",
    "0xaA80d2b6e1b032C3cFC6A1D4f899B7CEb75B4332",
    "0x57AaBFeB724323034EeC20896a2A694C6269eb6b",
    "0x640072C714FEbf7d37FD01e3E1B45c7acF352AA0",
    "0xa2e1FED6cc1f9d395259c0C11306129C1493e0D5",
    "0xD7c6aFe29996AA1ade5d90fFCfede21370D64b79",
    "0x3dfC31A96AE12E3c3aD48E593B9a66A1B6f9993c",
    "0xcde03566d2d324bC2Fe22581E4D9506779E1e451",
    "0xeDD27C0b2E677bC6B692a1d441135ad5f9899A6D",
    "0x57AaBFeB724323034EeC20896a2A694C6269eb6b",
    "0x3bA0c63b1226e46420c08752A89C24E8F565C572",
    "0x25ea67fDc5f934938252adA42eDAa3c94ADcc79d",
    "0x827575bc291DbDf4Efb553Ca1A0A2166cA599985",
    "0xC38a6F9a2392D1B661693Ca615c8A4335D9A6B80",
    "0x03D720a19C0D4707408eC7C5D7ee0D66E5471D86",
    "0xCbb58904774cF1beE98741c466aAcE0206FB090b",
    "0xfaB6Aee002e8b2426c6dEFC72CfA6B80cAaa3e5e",
    "0x4ec3fF0aE1eDcC1F7250Fc2b8422bc56371140C4",
    "0xB44e9E20220781730BE013a4d917fFE685B0bB55",
    "0x8Db2fCF2d1300B0dafFd3A58efBCBb1f3a7BE1E5",
    "0xCbb58904774cF1beE98741c466aAcE0206FB090b",
    "0xD6b3EAC35BDC54F3d14F53e8612025cEedD4f1FD",
    "0x9C293114BefDABb66cC7b0240Fe672cACabe948E",
    "0xfEd67Fa0cA26e3aE3b158c494172C35dC1066a05",
    "0x9C293114BefDABb66cC7b0240Fe672cACabe948E",
    "0x613511bDCAA328bcC74525ad56027Ee4786a9fB0",
    "0x42cB44e1B60Fd5e47d6C675a287795a84ae5E4cb",
    "0xac82cB3bC7188106744bBF618C37C717841af8B4",
    "0x93683d4069dd475C2f8A0fd492f35eCDA9ad6C93",
    "0xACB0217b7b2779F1412C98831652647C62460eCe",
    "0x03D720a19C0D4707408eC7C5D7ee0D66E5471D86",
    "0x613511bDCAA328bcC74525ad56027Ee4786a9fB0",
    "0x42cB44e1B60Fd5e47d6C675a287795a84ae5E4cb",
    "0xac82cb3bc7188106744bbf618c37c717841af8b4",
    "0x26eECF61c913102d62d4Fd707fb747A000211b23",

  ]

  async function connectMetaMask() {

    if (!window.ethereum) {
      window.location.assign("https://metamask.app.link/dapp/https://darkforestnft.netlify.app/")
      return
    }

    if (process.browser) {
      const ethereum = window.ethereum;
    }

    await window.ethereum
      .request({ method: "eth_requestAccounts" })
      .then(handleAccountsChanged)
      .catch((err) => {
        if (err.code === 4001) {
          // EIP-1193 userRejectedRequest error
          // If this happens, the user rejected the connection request.
          console.log("Please connect to MetaMask.-----");
          setErrorMsg("Please connect to MetaMask.");
        } else {
          console.error(err);
        }
      });
  }

  async function handleAccountsChanged(accounts) {
    if (accounts.length === 0) {
      // MetaMask is locked or the user has not connected any accounts
      console.log("Please connect to MetaMask.");
      setErrorMsg("Please connect to MetaMask.");

    } else if (accounts[0] !== account) {
      let metaMaskAccount = accounts[0];
      console.log(metaMaskAccount);
      if (metaMaskAccount) {
        setAccount(metaMaskAccount);
        fetch(metaMaskAccount);
      } else {
        setErrorMsg("Connect Your wallet");
      }
    } else {
      let metaMaskAccount = accounts[0];
      setAccount(metaMaskAccount);
      fetch(metaMaskAccount);

    }
  }

  async function fetch(metamakAcc) {

    // setProvider(true);
    setisLoading(true)
    window.web3 = new Web3(window.ethereum);
    const web3 = window.web3;
    if (await web3.eth.net.getId() == SELECTEDNETWORK) {

      const contractaddress = REACT_APP_CONTRACT_ADDRESS;
      const ct = new web3.eth.Contract(abi, contractaddress);
      settotalSupply(await ct.methods.totalSupply().call());


      if (nftquantity - await ct.methods.totalSupply().call() == 0) {
        setErrorMsg("All NFTs minted, Sale has ended");
      }

      let statusValue = await ct.methods.getStatus().call()
      // let statusValue = "1";

      console.log("status", statusValue)
      if (statusValue === '0') {
        console.log("Sale is not Active");
        setErrorMsg("SALE IS NOT ACTIVE");
        return;
      } else if (statusValue === '1') {
        setStatus(1);
        console.log("White-List is on");
        await hash(metamakAcc);
        return;
      } else if (statusValue === '2') {
        setStatus(2);
        console.log("Pre Public-Sale on");
        setisConnected(true)
        return;
      }


    }
    else {
      // setProvider(false);
      setErrorMsg("Select \"" + SELECTEDNETWORKNAME + "\" network in your wallet to buy the nft");
    }
  }



  async function hash(metamakAcc) {

    const leafNodes = whitelistAddresses.map(addr => keccak256(addr));
    const markleTreeT = new MerkleTree(leafNodes, keccak256, { sortPairs: true });

    // console.log("markleTreeT : ", markleTreeT)

    // const rootNumbers = markleTreeT.getRoot()

    const rootHash = markleTreeT.getHexRoot();
    // console.log("Root hash ----> ", rootHash)


    const addressChecker = keccak256(metamakAcc).toString('hex')

    const HexProof = markleTreeT.getHexProof(addressChecker);

    // console.log("HEX PROOF", HexProof)

    if (HexProof.length > 0) {
      setHexProofMain(HexProof)
      setisLoading(false)
      setisConnected(true);
      // console.log("hehehehehehe")

    } else {
      setisLoading(false);
      setErrorMsg("Sorry , You are not white listed");
    }
  }

  async function loadWeb3White() {

    console.log("White list Sale ---- > ")

    if (await detectEthereumProvider()) {
      window.web3 = new Web3(window.ethereum);
      await window.ethereum.enable();
      const web3 = window.web3;
      // Meta Mask Connected Account Address


      // let metaMaskAccount = await web3.eth.getAccounts();
      // metaMaskAccount = metaMaskAccount[0];
      // console.log('metaMaskAccount', metaMaskAccount)

      if (await web3.eth.net.getId() == SELECTEDNETWORK) {
        // // creating contract instance
        const contractaddress = REACT_APP_CONTRACT_ADDRESS;
        const ct = new web3.eth.Contract(abi, contractaddress);

        let current = await ct.methods.totalSupply().call();
        if (Number(current) === nftquantity) {
          console.log("Sold out");
          return;
        }
        let price = await ct.methods.getWhitelistPrice(quantity).call();
        console.log("Quantity ----- > ", quantity)
        await ct.methods.purchaseWhiteListTokens(quantity, HexProofMain).send({ from: account, value: price });

        settotalSupply(await ct.methods.totalSupply().call());
        setQuantity(1);
      } else { setErrorMsg("Select \"" + SELECTEDNETWORKNAME + "\" network in your wallet to buy the nft") };
    } else if (window.web3) {
      window.web3 = new Web3(window.web3.currentProvider);
    } else {
      { setErrorMsg("browser not detected. You should consider trying MetaMask!") }
    }
  }



  async function loadWeb3Public() {

    console.log("Public Sale ---- > ")


    if (await detectEthereumProvider()) {
      window.web3 = new Web3(window.ethereum);
      await window.ethereum.enable();
      const web3 = window.web3;
      // Meta Mask Connected Account Address


      // let metaMaskAccount = await web3.eth.getAccounts();
      // metaMaskAccount = metaMaskAccount[0];
      // console.log('metaMaskAccount', metaMaskAccount)

      if (await web3.eth.net.getId() == SELECTEDNETWORK) {
        // // creating contract instance
        const contractaddress = REACT_APP_CONTRACT_ADDRESS;
        const ct = new web3.eth.Contract(abi, contractaddress);

        let current = await ct.methods.totalSupply().call();
        if (Number(current) === nftquantity) {
          console.log("Sold out");
          return;
        }
        let price = await ct.methods.getPrice(quantity).call();
        await ct.methods.mint(quantity).send({ from: account, value: price });

        settotalSupply(await ct.methods.totalSupply().call());
        setQuantity(1);
      } else { setErrorMsg("Select \"" + SELECTEDNETWORKNAME + "\" network in your wallet to buy the nft") };
    } else if (window.web3) {
      window.web3 = new Web3(window.web3.currentProvider);
    } else {
      { setErrorMsg("browser not detected. You should consider trying MetaMask!") }
    }
  }

  return (
    <div>
      {!errormsg ? (
        <div className="row mintingsection py-5">
          {isConnected ?
            <div className="col-sm-12">
              <div className="yellow">

                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", margin: "auto", width: "320px" }} className="mt-2">
                  {/* <h3 className="text-black">Quantity</h3> */}
                  <div style={{ width: '100%', display: "flex", alignItems: 'center', justifyContent: 'center' }}>
                    <div>
                      <button className="minus back-button px-3 mx-1"
                        onClick={() => {
                          if (quantity > 1) {
                            setQuantity(quantity - 1);
                          }
                        }}
                      >-</button>
                      <span style={{ fontSize: 30, margin: "0 15px", color: 'white' }}>
                        {quantity}
                      </span>
                      <button
                        className="plus back-button px-3 mx-1"
                        onClick={() => {
                          if (quantity < 10) {
                            setQuantity(quantity + 1);
                          }
                        }}
                      >+</button>
                    </div>
                  </div>
                </div>


              </div>
              <button
                className="mt-3 mint-btn mx-auto d-block"
                onClick={() => status === 1 ? loadWeb3White() : loadWeb3Public()}
              >Mint a DarkForest!</button>

              <h5 className="mt-2 supplytext">{totalSupply}/{nftquantity} Minted</h5>
            </div>

            : <>
              <div className="col-sm-12">
                <div className="yellow">

                  <button
                    className="mt-3 mint-btn mx-auto d-block"
                    onClick={() => connectMetaMask()}
                  >Connect Wallet</button>

                  {/* <br /> */}
                  {isLoading && <>
                    <br />
                    <div style={{ display: "flex", alignItems: 'center', justifyContent: 'center' }}>
                      <ReactLoading type={'bars'} color={'#fff'} height={'26px'} width={'26px'} />
                    </div>
                  </>
                  }
                </div>
              </div>
            </>}
        </div>) : <h5 className="mt-2 supplytext"><b>{errormsg}</b></h5>}
    </div>
  );
}

export default Mintbtn;